import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-kt-drawer-activate", "data-kt-drawer-width", "data-kt-drawer-name", "data-kt-drawer-direction", "data-kt-drawer-toggle", "data-kt-drawer-close"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-kt-drawer": "true",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-activate": _ctx.activate,
    "data-kt-drawer-width": _ctx.width,
    "data-kt-drawer-name": _ctx.name,
    "data-kt-drawer-direction": _ctx.direction,
    "data-kt-drawer-toggle": _ctx.toggleButton,
    "data-kt-drawer-close": _ctx.closeButton
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}